import {BaseOptionsProps} from '../typings';
import {ListProps} from './typings';

export const categoryOptions: BaseOptionsProps[] = [
  {
    label: 'painting',
    value: 'painting',
    suboptions: [
      {label: 'acrylic', value: 'painting-acrylic'},
      {label: 'gouache', value: 'painting-gouache'},
      {label: 'mixed media', value: 'painting-mixed-media'},
      {label: 'oil', value: 'painting-oil'},
      {label: 'spray & graffiti', value: 'painting-spray-paint'},
      {label: 'watercolour', value: 'painting-watercolour'},
      {label: 'other', value: 'painting-other'},
    ],
  },
  {
    label: 'prints',
    value: 'prints',
    suboptions: [{label: 'other', value: 'prints-other'}],
    groups: [
      {
        label: 'handmade',
        suboptions: [
          {label: 'collagraph', value: 'prints-collagraphs'},
          {label: 'etching & engraving', value: 'prints-etchings-engravings'},
          {label: 'linocut', value: 'prints-linocuts'},
          {label: 'lithograph', value: 'prints-lithographs'},
          {label: 'monoprint', value: 'prints-monoprint'},
          {label: 'screenprint', value: 'prints-screenprint'},
          {label: 'woodcut', value: 'prints-woodcuts'},
        ],
      },
      {
        label: 'digital',
        suboptions: [
          {label: 'c-type', value: 'prints-c-type'},
          {label: 'giclée', value: 'prints-giclee'},
        ],
      },
    ],
  },
  {
    label: 'photography',
    value: 'photography',
    suboptions: [
      {label: 'black & white', value: 'photography-black-and-white'},
      {label: 'colour', value: 'photography-colour'},
      {label: 'manipulated', value: 'photography-manipulated'},
    ],
  },
  {
    label: 'sculpture',
    value: 'sculpture',
    suboptions: [
      {label: 'bronze', value: 'sculpture-bronze'},
      {label: 'clay', value: 'sculpture-clay'},
      {label: 'mixed media', value: 'sculpture-mixed-media'},
      {label: 'relief', value: 'sculpture-relief'},
      {label: 'stone', value: 'sculpture-stone'},
      {label: 'wood', value: 'sculpture-wood'},
      {label: 'other', value: 'sculpture-other'},
    ],
  },
  {
    label: 'drawing',
    value: 'drawing',
    suboptions: [
      {label: 'charcoal', value: 'drawing-charcoal'},
      {label: 'ink', value: 'drawing-ink'},
      {label: 'pastel', value: 'drawing-pastel'},
      {label: 'pencil', value: 'drawing-pencil'},
      {label: 'other', value: 'drawing-other'},
    ],
  },
  {
    label: 'collage',
    value: 'collage',
  },
];

export const categoryFilterList: Readonly<ListProps> = {
  type: 'radio',
  style: 'text',
  options: [
    {
      label: 'all art',
      value: 'all',
    },
    ...categoryOptions.map((category) => ({
      label: category.label,
      value: category.value,
      sublist: category.suboptions
        ? {
            type: 'radio' as const,
            style: 'button' as const,
            options: [
              {label: 'all', value: 'all'},
              ...category.suboptions.map((suboption) => ({
                label: suboption.label,
                value: suboption.value,
              })),
              ...(category.groups ?? []).map((group) => ({
                label: group.label,
                sublist: {
                  type: 'radio' as const,
                  style: 'button' as const,
                  options: [
                    ...group.suboptions.map((suboption) => ({
                      label: suboption.label,
                      value: suboption.value,
                    })),
                  ],
                },
              })),
            ],
          }
        : undefined,
    })),
  ],
};
